<template>
  <div v-if="items.length > 0">
    <div class="configurator__wrap">
      <div class="configurator__text">
        <div class="c-text">
          <div class="c-text__title">
            <slot name="selected-configuration"></slot>
          </div>
          <div class="c-text__description">
            <slot name="check-values"></slot>
          </div>
          <div class="c-text__list">
            <div v-for="(item, index) in items" :key="index" class="c-text__item">
              <div class="c-text__item-title"><span>{{ item.SELECT_TITLE }}</span></div>
              <div class="c-text__item-value"><span>{{ item.SELECTED.name }}</span></div>
            </div>
          </div>
          <div class="c-text__content">
            <div class="c-text__content-title">
              <slot name="important"></slot>
            </div>
            <div class="c-text__content-list">
              <slot name="content-list"></slot>
            </div>
          </div>
        </div>
      </div>
      <div class="configurator__img">
        <img :src="image ? image : ''" alt="Изображение" loading="lazy">
      </div>
    </div>
    <slot name="form"></slot>
  </div>
  <div v-else>
    Конфигурация не выбрана.
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name : "PageConfiguration",
  data()
  {
    return {
      items : [],
      image : ""
    };
  },
  computed : {
    ...mapState([
      "moduleConfigurator"
    ])
  },
  methods  : {
    getImageSrc( model, handle, side )
    {
      fetch("/api/configuration/scheme/get/" + model + "/" + handle + "/" + side + "/", {method : "GET"})
      .then(response => response.json())
      .then(async resp =>
      {
        if(resp.success !== true)
        {
          let errs = JSON.parse(resp.message);
          this.parse(errs);
          return "";
        }
        else
        {
          this.image                     = resp.data;
          this.moduleConfigurator.scheme = resp.data;
        }
      });
    }
  },
  created()
  {
    if(localStorage.steps && localStorage.readyForOrder === "true")
    {
      this.items = JSON.parse(localStorage.steps);
      let model  = "";
      let handle = "";
      let side   = "";
      this.items.forEach(
          el =>
          {
            if(el.SELECT_TITLE === "Модель")
            {
              model = el.ITEMS[el.SELECTED.id]["NAME"];
            }
            if(el.SELECT_TITLE === "Ручка")
            {
              handle = el.ITEMS[el.SELECTED.id]["NAME"];
            }
            if(el.SELECT_TITLE === "Сторона открывания")
            {
              side = el.ITEMS[el.SELECTED.id]["NAME"];
            }
          });
      this.getImageSrc(model, handle ? handle : false, side);
    }
  }
};
</script>

<style scoped>

</style>